const orientation = result => {
  let orientationStr = 'ONE_COLUMN'
  if (result && result.resultLayout) {
    orientationStr = result.resultLayout
  }
  return ` orientation-${orientationStr}`
}
export default orientation
